{
  "views": "Views",
  "boards": "Boards",
  "screens": "Screens",
  "federatedViews": "Federated views",
  "filter": {
    "inputPlaceholder": "Find {{type}}"
  }
}
